// extracted by mini-css-extract-plugin
export default {"loader":"loader--wG0Nc","layout":"layout--BUjMw","appear":"appear--V2Ptz"};